export default function isServer() {
    return import.meta.server || typeof window === 'undefined'
}
